import React, {Component} from 'react';
import { connect } from 'react-redux';

import Check from '../../../assets/img/icons/check.svg';
import PropTypes from "prop-types";
import config from '../../../config';

class BudgetCollaboration extends Component {
  static propTypes = {
    action: PropTypes.func,
    customOnChange: PropTypes.func,
    onChangeKey: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    single: PropTypes.bool,
  };

  static defaultProps = {
    value: [],
  };

  constructor(props) {
    super(props);
    this.selectItem = this.selectItem.bind(this);
  }

  selectItem(groupName) {
    const { props } = this;
    if(this.props.single) {
      this.props.customOnChange(this.props.onChangeKey, groupName===props.value?"":groupName);
      return;
    }

    if (props.value.includes(groupName)) {
      const newVal = [].concat(props.value);
      newVal.splice(newVal.indexOf(groupName), 1);
      this.props.customOnChange(this.props.onChangeKey, newVal);
    } else {
      this.props.customOnChange(this.props.onChangeKey, [groupName].concat(props.value));
    }
  }

  render() {
    const value = this.props.value || [];
    const { props } = this;

    return (
      <div className={'collaboration-container'}>
        <p>{props.title}</p>
        { (props.schoolClass.Groups) ?
          <div className={this.props.user.role === 'groupmember' ? 'groupmember-disabled' : ''}>
            {props.schoolClass.Groups.map(group => (
              props.group.GroupTheme.color !== group.GroupTheme.color ?
              (<div
                key={group.GroupTheme.id}
                className={'collaboration-item' + ((value.includes&&value.includes(group.GroupTheme.color)) || value === group.GroupTheme.color ? ' active' : '')}
                onClick={this.selectItem.bind(this, group.GroupTheme.color)}>
                <img alt={'group-icon'} src={config.apiUrl + (group.GroupTheme.badge)}/>
                <img src={Check} alt={'check'} className={'collaboration-checkmark'}/>
              </div>) : ''
            ))}
          </div>
        : null}
      </div>
    )
  }
}

export default connect(state => ({
  schoolClass: state.schoolClass,
  group: state.group,
  user: state.user,
}))(BudgetCollaboration);



// WEBPACK FOOTER //
// ./src/components/elements/StepThree/BudgetCollaboration.js